<template>
    <component v-if="column.prop && filterDef" :is="filterDef.component || 'el-input'" v-model="row[column.prop]" :column="column" v-bind="filterDef.props||{}" @search="handlerSubmit"></component>
</template>

<script setup>
import {getColumnFilter} from '../columnFilter'
import {computed} from 'vue'

const props = defineProps({
    row: {
        type: Object,
    },
    column: {
        type: Object
    },
})
const emit = defineEmits(['search'])

const filterDef = computed(() => getColumnFilter(props.column?.filter?.name || props.column?.filter))

const handlerSubmit = () => {
    emit('search', props.row, props.column)
}
</script>

<style lang="scss" scoped>

</style>